import React, { useEffect, useState } from 'react'
import DynamicTable from '../../components/DynamicTable'
import CssBaseline from '@material-ui/core/CssBaseline'
import useUIState from '../../hooks/useUIstate';
import { formatDateAndTimeDashboard, formatTimeDashboard } from '../../helpers/commonFunctions';
import ExportTransactionsButton from './ExportTransactionsButton';
import Modal from '@material-ui/core/Modal';
import { API } from 'aws-amplify';
import { useTranslation } from 'react-i18next';

function TransactionList(props) {
  const [data, setData]: [any[], any] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLines, setModalLines] = useState<string[]>([]);
  const { setShowLoadingModal, setToastMessage, setShowToastMessage, setToastType } = useUIState();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.transactionData.length) {
      selectTransactionData();
    }
    // eslint-disable-next-line
  }, [props.TransactionData])

  function showDispenseMessages(row) {
    setShowLoadingModal(false)
    API.get("AE", `/Stores/JofemarDispenseMessages?storeId=${props.storeId}&transactionId=${row.values.TransactionId}`, { response: true })
      .then(res => {
        console.log(res.data);
        const lines = res.data
          .sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
          .map(item => {
            const time = formatTimeDashboard(item.Timestamp);
            return `${time} ${item.DispensationStatus}`;
          });
        setModalLines(lines);
      })
      .catch(error => {
        console.log(error);
        setToastType("error");
        setToastMessage(t('transactionlist.error.getting-dispensemessages'));
        setShowToastMessage(true);
      })
      .finally(() => {
        setShowLoadingModal(false)
      })
    setModalOpen(true);
  }

  function selectTransactionData() {
    const transactionsData = JSON.parse(JSON.stringify(props.transactionData));
    let transactionsToRender: any[] = [];

    // order transactions (descending)
    const recentTransactions = transactionsData.sort((a, b) => {
      return new Date(b.TransactionDate).getTime() - new Date(a.TransactionDate).getTime();
    })

    // reduce to max first 25 transactions
    recentTransactions.splice(25);

    console.log(recentTransactions);
    console.log(props.products);

    // format renderData
    recentTransactions.forEach(transaction => {
      let transactionProductsString = "";

      transaction.ProductsSold.forEach(product => {
        const productExists = props.products.find(p => p.Id === product.ProductId)

        if (productExists) {
          const productInfo = props.products.find(p => p.Id === product.ProductId);

          // add to productsstring (productname + amount)
          transactionProductsString += productInfo.Title + ":   " + product.Units + "\n";
        }
      });

      transactionsToRender.push({
        TransactionId: transaction.TransactionId,
        HasMessages: transaction.HasDispenseMessages,
        TransactionDate: formatDateAndTimeDashboard(transaction.TransactionDate),
        TransactionProducts: transactionProductsString,
        TransactionTotalPrice: "\u20ac" + " " + transaction.AmountPaid?.toFixed(2)
      });
    })

    renderData(transactionsToRender);
  }

  async function renderData(transactionsToRender) {
    setData(transactionsToRender);
    setShowLoadingModal(false);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: '(+))',
        accessor: 'HasMessages',
        hide: true,
      },
      {
        Header: '(++))',
        accessor: 'TransactionId',
        hide: true,
      },
      {
        Header: t('transactionlist.transaction-datetime'),
        accessor: 'TransactionDate',
      },
      {
        Header: t('transactionlist.products'),
        accessor: 'TransactionProducts'
      },
      ,
      {
        Header: t('transactionlist.total-price'),
        accessor: 'TransactionTotalPrice'
      },
    ],
    []
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 className="mb-05">{t('transactionlist.recent-transactions')}</h2>
        <ExportTransactionsButton />
      </div>
      <CssBaseline />
      <DynamicTable
        className="TransactionList"
        columns={columns}
        data={data}
        loading={false}
        globalFilter={false}
        showMessages={showDispenseMessages}
      />
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <div style={{ background: "#fff", padding: 20, margin: "10% auto", maxWidth: 400 }}>
          <h3>{t('transactionlist.dispense-messages')}</h3>
          {modalLines.map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
          <button onClick={() => setModalOpen(false)}>{t('generic.close')}</button>
        </div>
      </Modal>
    </div>
  )
}

export default TransactionList;
